export default __webpack_public_path__ + "static/media/sidemenu_patient_phi_profile.b7c5362d.svg";